import axios from 'axios';
import { API_URL } from '../config/environment';

const TOKEN_KEY = 'auth_token';

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Store references for interceptors (set up after Pinia is initialized)
let authStore = null;
let notificationStore = null;
let router = null;

// Setup function to be called after stores are initialized
export function setupApiInterceptors(auth, notification, routerInstance) {
  authStore = auth;
  notificationStore = notification;
  router = routerInstance;
}

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;

    // Handle 401/403 errors (unauthorized/forbidden)
    if (status === 401 || status === 403) {
      // Use store if available, otherwise fallback to localStorage
      if (authStore) {
        authStore.logout();
      } else {
        localStorage.removeItem(TOKEN_KEY);
      }

      // Redirect to login if not already there
      const currentPath = window.location.pathname;
      if (currentPath !== '/' && currentPath !== '/register') {
        if (router) {
          router.push('/');
        } else {
          window.location.href = '/';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api; 